import { TAppError, IBaseAction } from '@/store/types/base.state';

import { ITaxResidence, ITaxResidenceBase } from '@/store/models/taxResidence.model';

export enum taxResidenceTypes {
  ADD_TAX_RESIDENCE = 'PROFILE.ADD_TAX_RESIDENCE',
  ADD_TAX_RESIDENCE_SUCCESS = 'PROFILE.ADD_TAX_RESIDENCE_SUCCESS',
  ADD_TAX_RESIDENCE_FAIL = 'PROFILE.ADD_TAX_RESIDENCE_FAIL',

  UPDATE_TAX_RESIDENCE = 'PROFILE.UPDATE_TAX_RESIDENCE',
  UPDATE_TAX_RESIDENCE_SUCCESS = 'PROFILE.UPDATE_TAX_RESIDENCE_SUCCESS',
  UPDATE_TAX_RESIDENCE_FAIL = 'PROFILE.UPDATE_TAX_RESIDENCE_FAIL',

  DELETE_TAX_RESIDENCE = 'PROFILE.DELETE_TAX_RESIDENCE',
  DELETE_TAX_RESIDENCE_SUCCESS = 'PROFILE.DELETE_TAX_RESIDENCE_SUCCESS',
  DELETE_TAX_RESIDENCE_FAIL = 'PROFILE.DELETE_TAX_RESIDENCE_FAIL',

  ADD_CHILD_TAX_RESIDENCE = 'PROFILE.ADD_CHILD_TAX_RESIDENCE',
  ADD_CHILD_TAX_RESIDENCE_SUCCESS = 'PROFILE.ADD_CHILD_TAX_RESIDENCE_SUCCESS',
  ADD_CHILD_TAX_RESIDENCE_FAIL = 'PROFILE.ADD_CHILD_TAX_RESIDENCE_FAIL',
}

export interface IAddTaxResidenceAction extends IBaseAction {
  type: typeof taxResidenceTypes.ADD_TAX_RESIDENCE;
  userId: number;
  batchIndex?: string;
}

export interface IAddTaxResidenceSuccessAction extends IBaseAction {
  type: typeof taxResidenceTypes.ADD_TAX_RESIDENCE_SUCCESS;
  userId: number;
  taxResidence: ITaxResidenceBase;
  batchIndex?: string;
}

export interface IAddTaxResidenceFailAction extends IBaseAction {
  type: typeof taxResidenceTypes.ADD_TAX_RESIDENCE_FAIL;
  userId: number;
  error: TAppError;
  batchIndex?: string;
}

export interface IUpdateTaxResidenceAction extends IBaseAction {
  type: typeof taxResidenceTypes.UPDATE_TAX_RESIDENCE;
  userId: number;
  taxResidenceId: number;
}

export interface IUpdateTaxResidenceSuccessAction extends IBaseAction {
  type: typeof taxResidenceTypes.UPDATE_TAX_RESIDENCE_SUCCESS;
  userId: number;
  taxResidence: ITaxResidence;
}

export interface IUpdateTaxResidenceFailAction extends IBaseAction {
  type: typeof taxResidenceTypes.UPDATE_TAX_RESIDENCE_FAIL;
  userId: number;
  taxResidenceId: number;
  error: TAppError;
}

export interface IDeleteTaxResidenceAction extends IBaseAction {
  type: typeof taxResidenceTypes.DELETE_TAX_RESIDENCE;
  taxResidenceId: number;
  userId: number;
}

export interface IDeleteTaxResidenceSuccessAction extends IBaseAction {
  type: typeof taxResidenceTypes.DELETE_TAX_RESIDENCE_SUCCESS;
  userId: number;
  taxResidenceId: number;
}

export interface IDeleteTaxResidenceFailAction extends IBaseAction {
  type: typeof taxResidenceTypes.DELETE_TAX_RESIDENCE_FAIL;
  userId: number;
  taxResidenceId: number;
  error: TAppError;
}

export interface IAddChildTaxResidenceAction extends IBaseAction {
  type: typeof taxResidenceTypes.ADD_CHILD_TAX_RESIDENCE;
  userId: number;
  parentId: number;
  batchIndex?: string;
}

export interface IAddChildTaxResidenceSuccessAction extends IBaseAction {
  type: typeof taxResidenceTypes.ADD_CHILD_TAX_RESIDENCE_SUCCESS;
  userId: number;
  parentId: number;
  taxResidence: ITaxResidenceBase;
  batchIndex?: string;
}

export interface IAddChildTaxResidenceFailAction extends IBaseAction {
  type: typeof taxResidenceTypes.ADD_CHILD_TAX_RESIDENCE_FAIL;
  userId: number;
  parentId: number;
  error: TAppError;
  batchIndex?: string;
}

export type TTaxResidenceGroupAction =
  | IAddTaxResidenceAction
  | IAddTaxResidenceSuccessAction
  | IAddTaxResidenceFailAction
  | IUpdateTaxResidenceAction
  | IUpdateTaxResidenceSuccessAction
  | IUpdateTaxResidenceFailAction
  | IDeleteTaxResidenceAction
  | IDeleteTaxResidenceSuccessAction
  | IDeleteTaxResidenceFailAction
  | IAddChildTaxResidenceAction
  | IAddChildTaxResidenceSuccessAction
  | IAddChildTaxResidenceFailAction;

export interface ISelectorsTaxResidence {
  items?: {};
  id?: number;
  create?: {};
}
